<div class="no-select overview-container total-step-width">
  <!--Separation-->
  @if (!displayError500Panels && isScrolledDownToShowTheAbstractHeader) {
    <div class="result-separator-on-scroll-down"></div>
  }

  <!--Scrolling management-->
  @if (!isScrolledDownToShowTheAbstractHeader) {
    <!--Overview abstract-->
    @if (!displayError500Panels) {
      <div class="overview-abstract">
        <!--Loader taking all space-->
        @if (!fetchingComplete) {
          <div class="no-select overview-loader transparent-effect card-info d-flex align-items-center justify-content-center">
            <app-simple-loader></app-simple-loader>
          </div>
        }
        <div class="alert-name d-flex justify-content-center align-items-center">
          <div class="text-center">
            {{ alertName ?? '' }}
          </div>
        </div>
        <!--Main container-->
        <div class="previous-next-period-container">
          <div class="left-part d-flex">
            <button class="align-middle" (click)="onNextPreview()">
              <div class="icon-btn icon-btn--arrow-left"></div>
            </button>
            <div class="d-table">
              <div class="d-table-cell title-date-numerical underline align-middle">
                {{ $safeNavigationMigration(territoryWatchDocumentPreviewPeriod?.from) | date: 'dd/MM/y' : '' : 'fr' }}
              </div>
            </div>
          </div>
          <div class="center-part d-table">
            <div class="title-date text-center d-table-cell align-middle">
              {{
                territoryWatchDocumentPreviewPeriod &&
                  (territoryWatchDocumentPreviewPeriod.territoryWatchDate | date: 'EEEE dd MMMM y' : '' : 'fr' | articleTitleCase)
              }}
            </div>
          </div>
          <div class="right-part d-flex">
            <div class="d-table">
              <div class="d-table-cell title-date-numerical underline align-middle">
                {{ $safeNavigationMigration(territoryWatchDocumentPreviewPeriod?.to) | date: 'dd/MM/y' : '' : 'fr' }}
              </div>
            </div>
            <button class="align-self-center" (click)="onPrevPreview()" [disabled]="!this.Params.territory_watch_offset">
              <div class="icon-btn icon-btn--arrow-right"></div>
            </button>
          </div>
        </div>
        <!--Describe the currently displayed period-->
        <div class="period-description d-flex flex-column align-middle justify-content-center">
          <div class="ligne-1 d-flex justify-content-center">
            {{ 'wizard.for-the-period' | translate }}
            <div class="ligne-1-dates d-flex">
              {{ $safeNavigationMigration(territoryWatchDocumentPreviewPeriod?.from) | date: 'dd/MM/y' : '' : 'fr' }}
              <div class="to">{{ 'wizard.to' | translate }}</div>
              {{ $safeNavigationMigration(territoryWatchDocumentPreviewPeriod?.to) | date: 'dd/MM/y' : '' : 'fr' }}
            </div>
          </div>
          <div class="ligne-2 text-center">
            {{ 'wizard.would-have-received' | translate }}
          </div>
        </div>
        <!--Contains icons w/ number of results-->
        <div class="found-documents-container d-flex align-middle justify-content-center">
          <div class="text-center">
            <div class="found-articles found-item d-flex align-middle">
              <div class="icon icon--article"></div>
              <div>
                {{ territoryWatchDocumentPreviewPeriod?.nbArticle }}
              </div>
              <div>
                {{ 'wizard.article' | translate }}
              </div>
            </div>
            <div class="found-project-publications found-item d-flex align-middle">
              <div class="icon icon--admin-doc"></div>
              <div>
                {{ territoryWatchDocumentPreviewPeriod?.nbProject }}
              </div>
              <div>
                {{ 'wizard.prefecture-and-mrae' | translate }}
              </div>
            </div>
            <div class="found-collectivity-publications found-item d-flex align-middle">
              <div class="icon icon--admin-doc"></div>
              <div>
                {{ territoryWatchDocumentPreviewPeriod?.nbAdminDoc }}
              </div>
              <div>
                {{ 'wizard.publication' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <div class="error-500-panel h-100 w-100">
        <div class="error-message-container h-100 w-100">
          <div class="error-img w-100">
            <img src="../../../assets/images/eye-off-icon.svg" alt="eye-off-icon" />
          </div>
          <div class="error-title" [innerHTML]="'wizard.overview-error-title' | translate"></div>
          <div class="error-message" [innerHTML]="'wizard.overview-error-message' | translate"></div>
        </div>
      </div>
    }
  }

  <!--Overview hidden abstract for scrolling management — may be used in the future...-->
  @if (!displayError500Panels && isScrolledDownToShowTheAbstractHeader) {
    <div class="abstract-hidden-container">
      <div class="overview-abstract overview-hidden">
        <!--Loader taking all space-->
        @if (!fetchingComplete) {
          <div class="no-select overview-loader transparent-effect card-info d-flex align-items-center justify-content-center">
            <app-simple-loader></app-simple-loader>
          </div>
        }
        <div class="alert-name d-flex justify-content-center align-items-center">
          <div class="text-center">
            {{ alertName ?? '' }}
          </div>
        </div>
        <!--Main container-->
        <div class="previous-next-period-container">
          <div class="left-part d-flex">
            <button class="align-middle" (click)="onNextPreview()">
              <div class="icon-btn icon-btn--arrow-left"></div>
            </button>
            <div class="d-table">
              <div class="d-table-cell title-date-numerical underline align-middle">
                {{ $safeNavigationMigration(territoryWatchDocumentPreviewPeriod?.from) | date: 'dd/MM/y' : '' : 'fr' }}
              </div>
            </div>
          </div>
          <div class="center-part d-table">
            <div class="title-date text-center d-table-cell align-middle">
              {{
                $safeNavigationMigration(territoryWatchDocumentPreviewPeriod?.territoryWatchDate)
                  | date: 'EEEE dd MMMM y' : '' : 'fr'
                  | articleTitleCase
              }}
            </div>
          </div>
          <div class="right-part d-flex">
            <div class="d-table">
              <div class="d-table-cell title-date-numerical underline align-middle">
                {{ $safeNavigationMigration(territoryWatchDocumentPreviewPeriod?.to) | date: 'dd/MM/y' : '' : 'fr' }}
              </div>
            </div>
            <button class="align-self-center" (click)="onPrevPreview()" [disabled]="!this.Params.territory_watch_offset">
              <div class="icon-btn icon-btn--arrow-right"></div>
            </button>
          </div>
        </div>
      </div>
    </div>
  }

  <!--Aperçu du contenu — titre-->
  @if (!displayError500Panels) {
    <div class="overview-title" [style.opacity]="isScrolledDownToShowTheAbstractHeader ? 0 : 1">
      {{ 'wizard.overview-content' | translate | uppercase }}
    </div>
  }

  <!--Aperçu du contenu — contenus-->
  @if (!displayError500Panels) {
    <div class="overview-previews-container no-select">
      <!--Loader taking top part space-->
      @if (!fetchingComplete) {
        <div
          [style.top.px]="getPartialUpLoaderToValueInPx()"
          class="no-select overview-loader--partial-up card-info d-flex align-items-center justify-content-center"
        >
          <app-simple-loader></app-simple-loader>
        </div>
      }
      <!--Transparent background taking all space-->
      @if (!fetchingComplete) {
        <div
          class="no-select overview-loader--full-down transparent-effect card-info d-flex align-items-center justify-content-center"
        ></div>
      }
      <div class="overview-previews bottom-side d-flex">
        <div class="overview-previews-list total-step-width">
          <ng-container>
            <!--Case results-->
            @if (totalCount > 0) {
              @for (preview of territoryWatchDocumentPreviews; track preview; let i = $index) {
                @if (preview?.cardType === IssuerSectionEnum.article) {
                  <app-article-card
                    [docId]="preview.id"
                    [allowOnClick]="false"
                    [title]="preview.title"
                    [publicationDate]="preview.publicationDate"
                    [source]="preview.source"
                    [text]="preview.excerpt"
                    [isPreview]="true"
                    [territories]="preview.territories"
                    [photoCount]="$safeNavigationMigration(preview.html?.nbImages)"
                    [showOccurrences]="false"
                  >
                  </app-article-card>
                }
                @if (preview?.cardType === IssuerSectionEnum.pref_and_mrae) {
                  <app-pref-and-mrae-doc-card
                    [docId]="preview.id"
                    [allowOnClick]="false"
                    [showOccurrences]="false"
                    [title]="preview.projectTitle"
                    [publicationDate]="preview.publicationDate"
                    [text]="preview.excerpt"
                    [url]="preview.url"
                    [website]="preview.website"
                    [isPreview]="true"
                    [territories]="preview.territories"
                    [displayedPublicationType]="preview.displayedPublicationType"
                    [publicationType]="preview.publicationType"
                    [inquirers]="$safeNavigationMigration(preview?.inquirers)"
                    [nbNewDocuments]="$safeNavigationMigration(preview?.nbDocs)"
                    [projectUid]="$safeNavigationMigration(preview?.projectUid)"
                  ></app-pref-and-mrae-doc-card>
                }
                @if (preview?.cardType === IssuerSectionEnum.admin_doc) {
                  <app-admin-doc-card
                    [showOccurrences]="false"
                    [allowOnClick]="false"
                    [docId]="preview.id"
                    [title]="preview.title"
                    [publicationDate]="preview.publicationDate"
                    [website]="preview.website"
                    [text]="preview.excerpt"
                    [isPreview]="true"
                    [url]="preview.url"
                    [displayedPublicationType]="preview.displayedPublicationType"
                  >
                  </app-admin-doc-card>
                }
                @if (preview?.cardType === IssuerSectionEnum.region_and_department) {
                  <app-region-and-department-doc-card
                    [showOccurrences]="false"
                    [allowOnClick]="false"
                    [docId]="preview.id"
                    [title]="preview.title"
                    [publicationDate]="preview.publicationDate"
                    [website]="preview.website"
                    [text]="preview.excerpt"
                    [isPreview]="true"
                    [territories]="preview.territories"
                    [url]="preview.url"
                    [displayedPublicationType]="preview.displayedPublicationType"
                  >
                  </app-region-and-department-doc-card>
                }
                <!--Line separator between contents-->
                @if (i < territoryWatchDocumentPreviews.length - 1) {
                  <div class="line-separator-container">
                    <div class="line-separator"></div>
                  </div>
                }
                @if (i < territoryWatchDocumentPreviews.length - 1) {}
                @if (territoryWatchDocumentPreviews.length === 1) {}
              }
              <!--End of ngFor-->
            }
            <!--End of case results-->
            <!--Case no result-->
            @if (totalCount === 0) {
              <div class="no-result no-select">
                <div>{{ 'wizard.overview-no-result-title' | translate }}</div>
                <div>{{ 'wizard.overview-no-result-sub-title' | translate }}</div>
              </div>
            }
            <!-- end of Case no result-->
          </ng-container>
        </div>
      </div>
    </div>
  }
</div>
